

















































































































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import {
  TenantNews,
  TenantEvent,
  Tenant,
  Coupon,
  MobileCoupon,
  Splash
} from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { autoclose } from "@/mixins";

const db = firebaseProject.firestore();

export default Vue.extend({
  name: "Side",
  mixins: [autoclose],
  data() {
    return {
      authentication,
      //countSplashPendingApproval: 0,
      countEventsPendingApproval: 0,
      countNewsPendingApproval: 0,
      countCouponPendingApproval: 0
      //countMobileCouponPendingApproval: 0
    };
  },
  async created() {
    const tenantIds = await (
      await db
        .collection("tenant")
        .where("shopId", "==", this.shopId)
        .get()
    ).docs.map(item => item.id);

    /*
    new List<Splash>(db.collectionGroup("splash") as firestore.Query<Splash>)
      .query({
        filter: {
          authorizeStatus: { $eq: 1 }
        },
        orderBy: [
          {
            field: "createTime",
            order: "desc"
          }
        ]
      })
      .ref?.get()
      .then(snapshot => {
        this.countSplashPendingApproval = snapshot.docs.filter(item => {
          const parentId = item?.ref?.parent.parent?.id;
          const indexOf = parentId && tenantIds.indexOf(parentId) != -1;
          return indexOf;
        }).length;
      });
    */

    const functions = firebaseProject.functions("asia-northeast1");
    const callableNews = functions.httpsCallable("consoleNews");
    callableNews({
      shopId: this.shopId,
      authorizeStatus: 1
    })
      .then(res => {
        console.log(res);
        if (res && res.data.status == "SUCCEED") {
          this.countNewsPendingApproval = res.data.maxNumber;
        }
      })
      .catch(e => {
        console.error(e);
      });

    const callableEvent = functions.httpsCallable("consoleEvent");
    callableEvent({
      shopId: this.shopId,
      authorizeStatus: 1
    })
      .then(res => {
        console.log(res);
        if (res && res.data.status == "SUCCEED") {
          this.countEventsPendingApproval = res.data.maxNumber;
        }
      })
      .catch(e => {
        console.error(e);
      });

    const callableCoupon = functions.httpsCallable("consoleCoupon");
    callableCoupon({
      shopId: this.shopId,
      authorizeStatus: 1
    })
      .then(res => {
        console.log(res);
        if (res && res.data.status == "SUCCEED") {
          this.countCouponPendingApproval = res.data.maxNumber;
        }
      })
      .catch(e => {
        console.error(e);
      });

    /*
    new List<MobileCoupon>(
      db.collectionGroup("mobileCoupon") as firestore.Query<MobileCoupon>
    )
      .query({
        filter: {
          authorizeStatus: { $eq: 1 }
        },
        orderBy: [
          {
            field: "createTime",
            order: "desc"
          }
        ]
      })
      .ref?.get()
      .then(snapshot => {
        this.countMobileCouponPendingApproval = snapshot.docs.filter(item => {
          console.log("item?.data", item?.data()?.tenantId);
          const tenantId = item?.data()?.tenantId;
          const indexOf = tenantId && tenantIds.indexOf(tenantId) != -1;
          return indexOf;
        }).length;
      });
    */
  },
  computed: {
    _path(): string {
      return this.$route.fullPath;
    },
    shopId(): string | undefined {
      return this.$config.shopId;
    }
  }
});
